// extracted by mini-css-extract-plugin
export var searchHeader = "_3n-0";
export var searchHeaderDark = "_3n-1";